import type { ApiClient } from "@carepass/api-client";
import type { Schemas } from "../workspace/api.generated";
import type { ProviderActiveFilter, ProviderModeFilter } from "./schema";

export interface ProviderConfigurationQuery {
  readonly providerCode: string;
  readonly serviceType: string;
  readonly providerMode: ProviderModeFilter;
  readonly active: ProviderActiveFilter;
  readonly page: number;
  readonly size: number;
}

export async function getProviderConfigurations(api: ApiClient, query: ProviderConfigurationQuery, signal?: AbortSignal) {
  return (await api.get<Schemas["ProviderConfigurationPage"]>("/api/v1/admin/provider-configurations", {
    query: {
      providerCode: query.providerCode || undefined,
      serviceType: query.serviceType || undefined,
      mode: query.providerMode || undefined,
      active: query.active ? query.active === "true" : undefined,
      page: query.page,
      size: query.size,
    },
    signal,
    cache: "no-store",
  })).data;
}

export async function createProviderConfiguration(api: ApiClient, body: Schemas["CreateProviderConfigurationRequest"], signal?: AbortSignal) {
  return (await api.post<Schemas["ProviderConfigurationView"], Schemas["CreateProviderConfigurationRequest"]>("/api/v1/admin/provider-configurations", body, { signal, cache: "no-store" })).data;
}
export async function getProviderConfiguration(api: ApiClient, configurationId: number, signal?: AbortSignal) {
  return (await api.get<Schemas["ProviderConfigurationView"]>(`/api/v1/admin/provider-configurations/${configurationId}`, { signal, cache: "no-store" })).data;
}
export async function getProviderCredentialHistory(api: ApiClient, configurationId: number, signal?: AbortSignal) {
  return (await api.get<Schemas["ProviderCredentialHistoryView"][]>(`/api/v1/admin/provider-configurations/${configurationId}/credentials/history`, { signal, cache: "no-store" })).data;
}
export async function rotateProviderCredential(api: ApiClient, configurationId: number, body: Schemas["RotateProviderCredentialRequest"], signal?: AbortSignal) {
  await api.put<void, Schemas["RotateProviderCredentialRequest"]>(`/api/v1/admin/provider-configurations/${configurationId}/credential`, body, { signal, cache: "no-store" });
}
export async function testProviderConnection(api: ApiClient, configurationId: number, signal?: AbortSignal) {
  return (await api.post<Schemas["ProviderConnectionTestResult"]>(`/api/v1/admin/provider-configurations/${configurationId}/connection-test`, undefined, { signal, cache: "no-store" })).data;
}
export async function activateProviderConfiguration(api: ApiClient, configurationId: number, signal?: AbortSignal) {
  return (await api.post<Schemas["ProviderConfigurationView"]>(`/api/v1/admin/provider-configurations/${configurationId}/activate`, undefined, { signal, cache: "no-store" })).data;
}
